<template>
  <div>
    <TablePro
      ref="tableProRef"
      v-bind="tableConfig"
      :actions="visible ? ['export'] : []">
      <template #tableBefore>
        <el-table-column type="selection" width="55" />
      </template>
      <template #actionArea="{ selectedList }">
        <el-button v-permission="['v6_investment_edit']" @click="onEdit"
          >新增</el-button
        >
        <ImportButton
          v-permission="['v6_investment_import']"
          title="导入"
          :downloadExcel="downloadExcel"
          :uploadExcel="uploadExcel" />
        <el-button
          v-permission="['v6_investment_edit']"
          @click="onDelete(selectedList)">
          删除
        </el-button>
      </template>
    </TablePro>
    <PopupForm
      ref="popupFormRef"
      width="50%"
      popup-type="drawer"
      :columns="popupFormColumns"
      :on-submit="onSubmit" />
  </div>
</template>
<script setup>
import { hasPermission } from '@/utils'
import TablePro, { render } from '@/components/TablePro'
import ImportButton from '@/components/TablePro/ImportButton'
import PopupForm from '@/components/FormPro/PopupForm.vue'
import { Message } from 'element-ui'
import { ref, computed } from 'vue'
import {
  addV6Investintent,
  updateV6Investintent,
  downloadV6InvestintentTemplate,
  exportV6Investintent,
  getV6InvestintentListPage,
  uploadV6InvestintentTemplate,
  deleteV6Investintent,
  getV6InvestintentDetail
} from './api'

const tableProRef = ref()
const tableConfig = {
  exportTaskType: 'serverTask',
  exportSupported: ['all'],
  defaultUnfoldSearchForm: true,
  autoWidthCell: true,
  async request({ exportColumns, ...params }, action) {
    if (action === 'serverTaskExport') {
      const { currPage, pageSize, ...restParams } = params
      const columnKeys = exportColumns.map(column => column.name).join(',')
      return exportV6Investintent({ ...restParams, columnKeys })
    }
    const res = await getV6InvestintentListPage(params)
    return {
      data: res.data.list,
      totalCount: res.data.totalCount
    }
  },
  columns: [
    { title: '签约月份', name: 'signMonth', search: true },
    { title: '客户名称', name: 'customerName' },
    { title: '省份', name: 'province', search: true },
    { title: '城市', name: 'city', search: true },
    { title: '区域', name: 'district' },
    { title: '签约经理', name: 'signManager', search: true },
    { title: '意向店态', name: 'intentStoreType' },
    { title: '计划面积 (m²)', name: 'plannedArea' },
    { title: '付款日期', name: 'paymentDate' },
    { title: '客户类型', name: 'customerType', search: true },
    { title: '客户进度', name: 'customerProgress', search: true },
    { title: '装补政策', name: 'decorationSubsidyPolicy' },
    { title: '位置系数', name: 'locationCoefficient' },
    { title: '特殊装补流程单号', name: 'specialDecorationFlowNo' },
    { title: '特殊装补备注', name: 'specialDecorationRemark' },
    { title: '额外礼包政策流程单号', name: 'extraGiftPolicyFlowNo' },
    { title: '额外礼包政策备注', name: 'extraGiftPolicyRemark' },
    { title: '额外礼包政策是否报销', name: 'extraGiftPolicyReimbursement' },
    { title: '加盟/转让流程编号', name: 'franchiseTransferFlowNo' },
    {
      title: '操作',
      width: 150,
      render: render((h, ctx) => {
        if (hasPermission('v6_investment_edit')) {
          return (
            <el-button
              type="text"
              onClick={() => {
                onDetail(ctx.data.id)
              }}>
              编辑
            </el-button>
          )
        }
      })
    }
  ]
}
const visible = computed(() => {
  return hasPermission('v6_investment_export')
})
const popupFormRef = ref()
const popupFormColumns = [
  { title: '签约月份', name: 'signMonth' },
  { title: '客户名称', name: 'customerName' },
  { title: '省份', name: 'province' },
  { title: '城市', name: 'city' },
  { title: '区域', name: 'district' },
  { title: '签约经理', name: 'signManager' },
  { title: '意向店态', name: 'intentStoreType' },
  { title: '计划面积 (m²)', name: 'plannedArea' },
  {
    title: '付款日期',
    name: 'paymentDate',
    valueType: 'date',
    dateProps: { type: 'date' }
  },
  { title: '客户类型', name: 'customerType' },
  { title: '客户进度', name: 'customerProgress' },
  { title: '装补政策', name: 'decorationSubsidyPolicy' },
  { title: '位置系数', name: 'locationCoefficient' },
  { title: '特殊装补流程单号', name: 'specialDecorationFlowNo' },
  { title: '特殊装补备注', name: 'specialDecorationRemark' },
  { title: '额外礼包政策流程单号', name: 'extraGiftPolicyFlowNo' },
  { title: '额外礼包政策备注', name: 'extraGiftPolicyRemark' },
  { title: '额外礼包政策是否报销', name: 'extraGiftPolicyReimbursement' },
  { title: '加盟/转让流程编号', name: 'franchiseTransferFlowNo' }
]
async function onSubmit(params) {
  try {
    const apiRequest = params.id ? updateV6Investintent : addV6Investintent
    await apiRequest(params)
    Message.success('操作成功')
    popupFormRef.value.onHide()
    tableProRef.value.onRefreshTableList()
  } catch (e) {
    //TODO handle the exception
  }
}
function downloadExcel() {
  downloadV6InvestintentTemplate()
}
async function uploadExcel(_, excel) {
  try {
    const formData = new FormData()
    formData.append('file', excel.raw)
    await uploadV6InvestintentTemplate(formData)
    Message.success('操作成功')
    tableProRef.value.onRefreshTableList()
  } catch (e) {
    //TODO handle the exception
  }
}
async function onDelete(selectedList) {
  try {
    if (selectedList.length === 0) {
      return Message.warning('请选择要删除的数据')
    }
    await deleteV6Investintent(selectedList.map(v => v.id))
    Message.success('操作成功')
    tableProRef.value.onRefreshTableList()
  } catch (e) {
    //TODO handle the exception
  }
}
function onEdit() {
  const form = {
    signMonth: '',
    customerName: '',
    province: '',
    city: '',
    district: '',
    signManager: '',
    intentStoreType: '',
    plannedArea: '',
    paymentDate: '',
    customerType: '',
    customerProgress: '',
    decorationSubsidyPolicy: '',
    locationCoefficient: '',
    specialDecorationFlowNo: '',
    specialDecorationRemark: '',
    extraGiftPolicyFlowNo: '',
    extraGiftPolicyRemark: '',
    extraGiftPolicyReimbursement: '',
    franchiseTransferFlowNo: ''
  }
  popupFormRef.value?.onShow(form, undefined, {
    title: '新增意向客户'
  })
}
async function onDetail(id) {
  const res = await getV6InvestintentDetail(id)
  popupFormRef.value?.onShow(res.data, undefined, {
    title: '编辑意向客户'
  })
}
</script>
